import { render } from "./AttendantsDayPage.vue?vue&type=template&id=5c532508&scoped=true"
import script from "./AttendantsDayPage.vue?vue&type=script&lang=js"
export * from "./AttendantsDayPage.vue?vue&type=script&lang=js"

import "./AttendantsDayPage.vue?vue&type=style&index=0&id=5c532508&scoped=true&lang=css"
import "./AttendantsDayPage.vue?vue&type=style&index=1&id=5c532508&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c532508"]])

export default __exports__